import Vue from 'vue'
import NarasiPlayer from './components/Player';

Vue.component('NarasiPlayer', NarasiPlayer)

export default NarasiPlayer;